import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import styles from "components/common/modal/styles.module.css";
import WithdrawalRequestItem from "./withdrawal-request-item";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { useAppSelector, useAppDispatch } from "state/hooks";
import { 
  getWithdrawalRequestsState, 
  fetchWithdrawalRequests
} from "state/slices/user-withdrawal-requests-slice";
import {
  getBankAccountsState,
  fetchBankAccounts
} from "state/slices/bank-accounts-slice";

interface WithdrawalRequestsModalProps {
  show: boolean;
  onHide: () => void;
}

const WithdrawalRequestsModal: React.FC<WithdrawalRequestsModalProps> = ({ show, onHide }) => {
  const dispatch = useAppDispatch();
  const { 
    withdrawalRequests, 
    fetchStatusState
  } = useAppSelector(getWithdrawalRequestsState);
  
  const { 
    accounts: bankAccounts,
    fetchStatusState: fundingSourcesFetchState 
  } = useAppSelector(getBankAccountsState);

  useEffect(() => {
    if (show) {
      dispatch(fetchWithdrawalRequests());
      dispatch(fetchBankAccounts());
    }
  }, [show, dispatch]);

  const getFundingSourceById = (id: string) => {
    return bankAccounts.find((account) => account.id === id);
  };

  const renderContent = () => {
    if (fetchStatusState === "loading") {
      return (
        <div className={"text-center"} style={{ color: "white", padding: "20px" }}>
          <div>Loading withdrawal requests...</div>
        </div>
      );
    }

    if (fetchStatusState === "failed") {
      return (
        <div className={"text-center"} style={{ color: "#FF4444", padding: "20px" }}>
          <div>Failed to load withdrawal requests. Please try again.</div>
        </div>
      );
    }

    if (withdrawalRequests.length === 0) {
      return (
        <div className={"text-center"} style={{ color: "white", padding: "20px" }}>
          <div>No withdrawal requests found</div>
        </div>
      );
    }

    return (
      <div
        style={{
          padding: "8px 16px",
          margin: "0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {withdrawalRequests.map((request) => {
          const fundingSource = getFundingSourceById(request.paynote_funding_source_id);
          return (
            <WithdrawalRequestItem 
              key={request.id} 
              withdrawalRequest={request}
              fundingSource={fundingSource}
            />
          );
        })}
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} dialogClassName={styles.modal}>
      <Modal.Header 
        className={styles.modalHeader}
        style={{ display: "flex", justifyContent: "center", position: "relative" }}
      >
        <div style={{ textAlign: "center" }}>
          <Modal.Title className={styles.modalTitle}>
            <BlockyHeavyText>My Withdrawal Requests</BlockyHeavyText>
          </Modal.Title>
        </div>
        <div 
          className={"bold"}
          style={{ 
            position: "absolute", 
            right: "16px", 
            top: "50%", 
            transform: "translateY(-50%)", 
            zIndex: 1 
          }}
        >
          <X size={40} style={{ cursor: "pointer", color: "white" }} onClick={onHide} />
        </div>
      </Modal.Header>

      <Modal.Body 
        className={styles.modalBody} 
        style={{ 
          paddingLeft: 0, 
          paddingRight: 0,
          maxHeight: "70vh",
          overflowY: "auto"
        }}
      >
        {renderContent()}
      </Modal.Body>
    </Modal>
  );
};

export default WithdrawalRequestsModal; 